<template>
  <div
    :id="layout"
    :class="palette"
    class="app-template"
  >
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AppTemplate',

  computed: {
    ...mapGetters(['layout', 'theme', 'palette']),
  },

  mounted() {
    this.setColorScheme();
  },

  methods: {
    setColorScheme() {
      document.querySelector('body').classList.add(this.theme);
    },
  },
};
</script>
